// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".airport-form .el-form-item.airport-name .el-input__inner {\n  width: 49em;\n}", ""]);
// Exports
module.exports = exports;
